import { Children, PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withApollo } from 'react-apollo'

import { compose, getContext, withHandlers } from 'recompose'

import { Account, ActionFeedContext } from 'generated/types'

import openAccountsQuery from './openAccounts.query.gql'

export type WithOpenAccountsProps = {
  openAccounts: Account[]
  getAccountIdForFeedContext: (
    accounts: Account[],
    feedContext: ActionFeedContext,
  ) => string | null
}

export const feedContextToAccounts: { [key: string]: string[] } = {
  a4Home: ['basic'],
  a4Invest: ['basic'],
  a4Later: ['traditionalIra', 'sepIra', 'rothIra'],
  a4Spend: ['checking'],
  a4Early: ['ugma', 'utma'],
  a4EarlyDetails: ['ugma', 'utma'],
}

export class OpenAccountsProvider extends PureComponent<
  any,
  { openAccounts: Account[]; loading: boolean }
> {
  public static propTypes = {
    openAccounts: PropTypes.array,
  }

  public static childContextTypes = {
    openAccounts: PropTypes.array,
  }

  constructor(props: any) {
    super(props)
    this.state = {
      openAccounts: [],
      loading: true,
    }

    this.getUsersOpenAccounts()
  }

  public getChildContext() {
    const { openAccounts } = this.state

    return { openAccounts }
  }

  public render() {
    return Children.only(this.props.children)
  }

  private getUsersOpenAccounts = () => {
    this.props.client
      .query({ query: openAccountsQuery })
      .then(({ data }: any) => {
        this.setState({ openAccounts: data.accounts, loading: false })
      })
      .catch(() => this.setState({ loading: false }))
  }
}

export const withOpenAccounts = compose<{ openAccounts: Account[] }, {}>(
  getContext({
    openAccounts: PropTypes.array,
  }),
  withHandlers({
    getAccountIdForFeedContext:
      () => (accounts: Account[], feedContext: ActionFeedContext) => {
        return (
          accounts?.filter((acct) =>
            feedContextToAccounts[feedContext as string]?.includes(
              acct.accountType,
            ),
          )?.[0]?.id ??
          null ??
          null
        )
      },
  }),
)

export const enhance = compose(withApollo)

export const Provider = enhance(OpenAccountsProvider)
